<div class="component-content paged heightcls" *ngIf="!association">
    <document-filter></document-filter>
    <table class="table m-table table-bordered table-hover table-heading">
        <colgroup>
            <col style="width: auto" />
            <col style="width: 10%" />
            <col style="width: 10%" />
            <col style="width: 10%" />
            <col style="width: 10%" />
            <col style="width: 10%" />
            <col style="width: 10%" />
            <col style="width: 10%" />
        </colgroup>
        <thead>
            <tr>
                <th>
                    <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Product Name</span>
                    <br />
                    <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">File Name</span>
                </th>
                <th>
                    <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Version</span>
                    <br />
                    <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Updated</span>
                </th>
                <th>
                    <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Replaces</span>
                    <br />
                    <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Version</span>
                </th>
                <th>
                    <br />
                    <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Model</span>
                </th>
                <th>
                    <br />
                    <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Powered By</span>
                </th>
                <th>
                    <br />
                    <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Suite</span>
                </th>
                <th>
                    <br />
                    <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">System</span>
                </th>
                <th>
                    <br />
                    <span style="line-height: 1.42857143; font-weight:bold; vertical-align:middle; text-align:center;">Language</span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let document of documents.Data" (click)="showHistory(document)">
                <td>
                    <span *ngIf="document.Publishing" class="text-success fa fa-check-circle"></span>
                    <span *ngIf="!document.Publishing" class="text-danger fa fa-warning"></span>
                    <span>{{ document.FileName }}</span>
                    <br />
                    <span>{{ document.ProductName }}</span>
                </td>
                <td>
                    <span>{{ document.Version }}</span>
                    <br />
                    <span>{{ document.VersionDate | amDateFormat: 'MM/DD/YYYY' }}</span>
                </td>
                <td>
                    <span>{{ document.UpdateTo?.Version }}</span>
                    <br />
                    <span>{{ document.UpdateTo?.VersionDate | amDateFormat: 'MM/DD/YYYY' }}</span>
                </td>
                <td style="vertical-align:middle; text-align:center; line-height: 2.75em;" [ngClass]="document.Color[0]">
                    <i class="fa fa-lg" [ngClass]="document.Match[0]"></i>
                </td>
                <td style="vertical-align:middle; text-align:center; line-height: 2.75em;" [ngClass]="document.Color[1]">
                    <i class="fa fa-lg" [ngClass]="document.Match[1]"></i>
                </td>
                <td style="vertical-align:middle; text-align:center; line-height: 2.75em;" [ngClass]="document.Color[2]">
                    <i class="fa fa-lg" [ngClass]="document.Match[2]"></i>
                </td>
                <td style="vertical-align:middle; text-align:center; line-height: 2.75em;" [ngClass]="document.Color[3]">
                    <i class="fa fa-lg" [ngClass]="document.Match[3]"></i>
                </td>
                <td style="vertical-align:middle; text-align:center; line-height: 2.75em;" [ngClass]="document.Color[4]">
                    <i class="fa fa-lg" [ngClass]="document.Match[4]"></i>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div class="paging-container" *ngIf="!association" style="position:fixed;bottom:50px;margin:0 auto;padding-left:20%">
    <div class="text-center" *ngIf="documents">
        <pagination [totalItems]="total" [itemsPerPage]="10" [maxSize]="10" [boundaryLinks]="true" [(ngModel)]="currentPage" (pageChanged)="getPage($event.page)"></pagination>
    </div>
</div>

<document-history *ngIf="!association"></document-history>


<div *ngIf="!isPreset" style="height:100%">
    <div class="panel panel-success" *ngIf="association" style="height:95%">
        <div class="panel-heading">
            <div *ngIf="showPresetOption">
                <h5 style="display: inline-block">
                    <span class="badge">{{ filteredDocuments.length }} / {{ total }}</span>
                    <span>Available Documents</span>
                </h5>
                <div class="pull-right">
                    <button type="button" class="btn btn-primary" title="To Select from Preset" (click)="togglePreset()">
                        <div style="text-align:center;">
                            <span>D&nbsp;&nbsp;</span><i class="fa fa-exchange"></i><span>&nbsp;&nbsp;P</span>
                        </div>
                    </button>
                    <div class="btn-group btn-group-md">
                        <advanced-document-filter></advanced-document-filter>
                    </div>
                </div>
            </div>
            <div *ngIf="!showPresetOption">
                <h5 style="display: inline-block">
                    <span class="badge">{{ filteredDocuments.length }} / {{ total }}</span>
                    <span>Available Documents</span>
                </h5>
                <div class="pull-right">
                    <div class="btn-group btn-group-md">
                        <advanced-document-filter></advanced-document-filter>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel-body panel-list" style="height:95%; overflow-y:hidden; padding-bottom:0px; padding-top:0px;">
            <div class="panel-group" style="height:95%; overflow-y:auto;">
                <div *ngIf="processing" class="list-group">
                    <i class="fa fa-spinner fa-spin"></i> Loading Documents...
                </div>
                <div class="list-group" style="overflow-y: auto;" *ngIf="!processing">
                    <div class="list-group-item" [class.list-group-item-success]="document.Selected" style="padding-top:0px; padding-bottom:0px;" *ngFor="let document of filteredDocuments" (click)="selectDocument(document)">
                        <h5 style="display: inline-block">
                            <span class="badge"> {{ document.EquipmentCount }}</span>
                            {{ document.FileName }}
                            <br />
                            {{ document.ProductName }}
                        </h5>
                        <div class="pull-right" style="padding-right:30px;">
                            <h5 class=" label label-info">
                                {{ document.Updated | amDateFormat: 'MM/DD/YYYY'  }}
                                <br />
                                {{ document.Version }}
                            </h5>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="panel panel-success" *ngIf="association && isPreset && showPresetOption" style="height:95%">
    <div class="panel-heading">
        <h5 style="display: inline-block">
            <span class="badge">{{ filteredPresets.Data.length }} / {{ presetsTotal }}</span>
            <span>Preset Packages</span>
        </h5>
        <div class="pull-right">
            <button type="button" class="btn btn-primary" title="To Select from Document" (click)="togglePreset()">
                <div style="text-align:center;">
                    <span>D&nbsp;&nbsp;</span><i class="fa fa-exchange"></i><span>&nbsp;&nbsp;P</span>
                </div>
            </button>
            <div class="btn-group btn-group-md">
                <preset-filter></preset-filter>
            </div>
        </div>
    </div>
    <div class="panel-body panel-list" style="overflow-y:hidden; padding-bottom:0px; padding-top:0px;">
        <div class="panel-group" style="height:95%; overflow-y:hidden;">
            <div *ngIf="processing" class="list-group">
                <i class="fa fa-spinner fa-spin"></i> Loading Presets...
            </div>
            <div class="list-group" *ngIf="!processing" style="height: 100%; overflow-y: auto;">
                <div class="list-group-item" [class.list-group-item-success]="preset.Selected" *ngFor="let preset of filteredPresets.Data" (click)="selectPreset(preset.Id)">
                    <h5>
                        {{ preset.PresetName }}
                        <br />
                    </h5>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
    </div>
</div>


